import { IonContent, IonHeader, IonPage } from '@ionic/react'
import Header from '../../components/header'
import { OneShopUsersTable } from '../../internal/user/components/oneshop-users-table'
import { OneShopMessageStatsMulti } from '../../internal/message/components/oneshop-message-stats'
import { OneShopBroadcastTable } from '../../internal/broadcast/components/oneshop-broadcasts-table'

function OneShopPage() {
  return (
    <IonPage>
      <IonHeader>
        <Header title="OneShop" btn={null} showMenu />
      </IonHeader>
      <IonContent>
        <OneShopUsersTable />
        <OneShopMessageStatsMulti />
        <OneShopBroadcastTable />
      </IonContent>
    </IonPage>
  )
}

export { OneShopPage }
